module.exports = __webpack_public_path__ + "static/053_anagl_altana_2-0d05d334f80aabccad3b11459fe61fd1.jpg";